import { motion } from "framer-motion";

// Ambient life — the world should never feel empty.

function ButterflySprite({ wing, body = "#2B2D42", className }) {
  return (
    <svg viewBox="0 0 40 34" className={className} aria-hidden>
      <motion.g animate={{ scaleX: [1, 0.4, 1] }} transition={{ duration: 0.5, repeat: Infinity, ease: "easeInOut" }} style={{ originX: "50%", originY: "50%" }}>
        <ellipse cx="12" cy="12" rx="9" ry="8" fill={wing} opacity="0.9" />
        <ellipse cx="28" cy="12" rx="9" ry="8" fill={wing} opacity="0.9" />
        <ellipse cx="14" cy="24" rx="6" ry="5" fill="#FFD166" />
        <ellipse cx="26" cy="24" rx="6" ry="5" fill="#FFD166" />
      </motion.g>
      <rect x="18" y="7" width="4" height="22" rx="2" fill={body} />
    </svg>
  );
}

export function Ambient({ reduce }) {
  if (reduce) return null;
  return (
    <div aria-hidden className="pointer-events-none absolute inset-0 z-[15] overflow-hidden">
      {/* wandering butterflies */}
      <motion.div
        className="absolute left-[12%] bottom-[34%]"
        animate={{ x: [0, 90, 210, 320, 220, 90, 0], y: [0, -46, -12, -60, -24, -52, 0] }}
        transition={{ duration: 34, repeat: Infinity, ease: "easeInOut" }}
      >
        <ButterflySprite wing="#FF7A45" className="h-5 w-6 sm:h-6 sm:w-7" />
      </motion.div>
      <motion.div
        className="absolute right-[16%] bottom-[26%]"
        animate={{ x: [0, -120, -240, -140, -40, 0], y: [0, -34, -70, -20, -56, 0] }}
        transition={{ duration: 40, delay: 4, repeat: Infinity, ease: "easeInOut" }}
      >
        <ButterflySprite wing="#118AB2" className="h-4 w-5 sm:h-5 sm:w-6" />
      </motion.div>

      {/* drifting dandelion seeds */}
      {[["24%", "18%", 0], ["55%", "12%", 5], ["78%", "20%", 9]].map(([left, bottom, delay], i) => (
        <motion.svg
          key={i}
          viewBox="0 0 20 20"
          className="absolute h-3 w-3 opacity-70"
          style={{ left, bottom }}
          animate={{ y: [0, -130], x: [0, i % 2 ? 34 : -28], opacity: [0, 0.8, 0] }}
          transition={{ duration: 12, delay, repeat: Infinity, ease: "easeInOut" }}
        >
          <circle cx="10" cy="10" r="2" fill="#FFFFFF" />
          {[0, 45, 90, 135].map((a) => (
            <line key={a} x1="10" y1="3" x2="10" y2="17" stroke="#FFFFFF" strokeWidth="1" transform={`rotate(${a} 10 10)`} />
          ))}
        </motion.svg>
      ))}

      {/* gentle wind streaks */}
      {[["18%", "42%", 0], ["62%", "48%", 6]].map(([left, top, delay], i) => (
        <motion.svg
          key={`w-${i}`}
          viewBox="0 0 80 16"
          className="absolute h-3 w-16"
          style={{ left, top }}
          animate={{ x: [0, 60], opacity: [0, 0.5, 0] }}
          transition={{ duration: 7, delay, repeat: Infinity, ease: "easeInOut" }}
        >
          <path d="M2 8 Q20 2 40 8 Q60 14 78 8" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" fill="none" />
        </motion.svg>
      ))}
    </div>
  );
}
